<template>
  <div id="step-3" class="multi-step-form active-step">
    <div class="d-flex align-content-center">
      <p>
        <img src="@/assets/arrow-left.svg" alt="OK" @click="prevEtapa()" />
      </p>
    </div>
    <div
      class="d-flex align-content-center align-flex-title"
      style="margin-top: -55px"
    >
      <p>Vamos iniciar a simulação do seu plano de saúde?</p>
    </div>
    <div class="align-flex-title">
      <h3>Selecione a sua identificação</h3>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>Selecione a sua Entidade de Classe:</p>
      <!-- <b-form-select v-model="selected_entidade" :options="options_entidades" @change="getProfissoes('entidadeclasse')" :class="{ 'statusok-fontbold': selected_entidade != 'null' }" :style="[ selected_entidade != 'null' ? { 'background': 'url(' + require('@/assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                    <b-form-select-option :value="null">Digite ou selecione aqui a sua entidade</b-form-select-option>
                  </b-form-select> -->
      <template
        v-if="options_entidades != undefined || options_entidades != null"
      >
        <autocomplete
          :source="options_entidades"
          :showNoResults="false"
          placeholder="Digite ou selecione aqui a sua Entidade"
          inputClass="form-control"
          :initialValue="null"
          resultsValue="name"
          @selected="getProfissoes"
          :class="{
            'statusok-fontbold-autocomplete': selected_entidade != 'null',
          }"
          :style="[
            selected_entidade != 'null'
              ? {
                  background:
                    'url(' +
                    require('@/assets/statusok.svg') +
                    ') no-repeat right 2.6% center #ffffff',
                }
              : '',
          ]"
        >
        </autocomplete>
      </template>
      <small>
        <b-icon icon="exclamation-circle" style="margin-right: 5px"></b-icon>
        Entidade de classe é um grupo que reúne pessoas da mesma profissão.
      </small>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
      v-if="preenchido && options_profissoes.length > 0"
    >
      <p>Qual sua profissão?</p>
      <!-- <b-form-select v-model="selected_profissao" :options="options_profissoes" @change="setEtapa('step-3','step-4', tipoorgaoentidade)" :class="{ 'statusok-fontbold': selected_profissao != 'null' }" :style="[ selected_profissao != 'null' ? { 'background': 'url(' + require('@/assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                    <b-form-select-option :value="null">Selecione aqui a sua Profissão</b-form-select-option>
                  </b-form-select> -->
      <template
        v-if="options_profissoes != undefined || options_profissoes != null"
      >
        <autocomplete
          :source="options_profissoes"
          :showNoResults="false"
          placeholder="Digite ou selecione sua Profissão"
          inputClass="form-control"
          :initialValue="null"
          @selected="setProfissao"
          :class="{
            'statusok-fontbold-autocomplete': selected_profissao != 'null',
          }"
          :style="[
            selected_profissao != 'null'
              ? {
                  background:
                    'url(' +
                    require('@/assets/statusok.svg') +
                    ') no-repeat right 2.6% center #ffffff',
                }
              : '',
          ]"
        >
        </autocomplete>
      </template>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div v-if="errors.length">
      <b v-for="erro in errors" :key="erro">{{ erro }}</b>
    </div>
    <!-- TESTE VALIDAÇÃO -->
  </div>
</template>

<script>
import store from "@/store";
import buscarEntidadeOrgaoAPI from "@/services/buscarEntidadeOrgaoAPI";
import buscarProfissoesAPIWP from "@/services/buscarProfissoes";

export default {
  name: "StepTres",
  data() {
    return {
      preenchido: false,
      errors: [],
    };
  },
  computed: {
    estadoid() {
      return store.getters.getAliancaEstadoID;
    },
    etapa: {
      get() {
        return store.getters.getAliancaProxEtapa;
      },
      set(newVal) {
        store.commit("mutAliancaProxEtapa", newVal);
      },
    },
    options_entidades: {
      get() {
        return store.getters.getSimuleAquiEntidades;
      },
      set(newVal) {
        store.commit("mutSimuleAquiEntidades", newVal);
      },
    },
    selected_entidade: {
      get() {
        return store.getters.getSimuleAquiSelectedEntidade;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedEntidade", newVal);
      },
    },
    selected_profissao: {
      get() {
        return store.getters.getSimuleAquiSelectedProfissao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedProfissao", newVal);
      },
    },
    options_profissoes: {
      get() {
        return store.getters.getSimuleAquiProfissoes;
      },
      set(newVal) {
        store.commit("mutSimuleAquiProfissoes", newVal);
      },
    },
    tipoorgaoentidade: {
      get() {
        return store.getters.getSimuleAquiTipoOrgaoEntidade;
      },
      set(newVal) {
        store.commit("mutSimuleAquiTipoOrgaoEntidade", newVal);
      },
    },
  },
  mounted() {
    document.getElementById("step-progress").value = 6.67 * 2;
  },
  methods: {
    prevEtapa() {
      store.commit("mutAliancaProxEtapa", "step-2");
    },
    validaStep() {
      this.errors = [];

      if (this.selected_entidade == null) {
        this.errors.push("Selecione uma entidade de classe válida");
        return false;
      }

      if (this.selected_profissao == null) {
        this.errors.push("Selecione uma profissão válida");
        return false;
      }

      return true;
    },
    async getProfissoes(group) {
      store.commit("mutSimuleAquiLoader", true);

      this.options_profissoes = [];

      group = group.selectedObject;

      this.selected_entidade = group.name;

      const profissoes = await buscarProfissoesAPIWP(group.id);

      this.options_profissoes = profissoes.map((el) => {
        return {
          id: el.profissao_id,
          name: el.profissao_title,
          slug: el.profissao_slug,
        };
      });

      // flag criada para saber se um valor já foi escolhido
      this.preenchido = true;

      store.commit("mutSimuleAquiLoader", false);

      await this.getOrgaoEntidadeData(group);

      store.dispatch("disAliancaEntidadeInfo");
    },
    async setProfissao(group) {
      group = group.selectedObject;

      this.$emit("set-entidade-orgao", group);

      await this.getOrgaoEntidadeData(group);

      this.selected_profissao = group.id || "";

      this.setEtapa();
    },
    async getOrgaoEntidadeData(group) {
      const selectedOrgaoEntidade = await buscarEntidadeOrgaoAPI(group.id);

      this.selected_orgao = group.name;

      store.commit(
        "mutAliancaNumeroContrato",
        selectedOrgaoEntidade.custom_fields.numerocontrato
      );
      store.commit(
        "mutAliancaSubFatura",
        selectedOrgaoEntidade.custom_fields.subfatura
      );

      this.tipoorgaoentidade = "entidade";

      store.commit("mutAliancaEntidadeClasse", this.selected_entidade);

      store.dispatch("disAliancaOperadorasConvenio");
    },
    setEtapa() {
      if (!this.validaStep()) {
        return;
      }

      console.log("Entidade selecionada: ", this.selected_entidade);

      store.commit("mutAliancaProfissao", this.selected_profissao);

      this.etapa = "step-4";

      store.commit("mutSimuleAquiLoader", true);
    },
  },
};
</script>